export class SearchedAdminUserModel {
  firstName: string;
  lastName: string;
  email: string;
}
